var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-name",class:{visible: this.visible}},[_c('div',{staticClass:"text"},[_vm._v("AFI Tower")])])}
var staticRenderFns = []

export { render, staticRenderFns }